export default __webpack_public_path__ + "img/15162061fc128fd003d6a2de64f0aaf7.png";